import Principal from '../screens/Principal.vue'
import Ano from '../screens/Ano.vue'
import NCM from '../screens/NCM.vue'
export const routes = [     
    {path:'/',name:'principal', component: Principal},    


    {path:'/estado',name:'ano', component: Ano,beforeEnter:(to,from,next)=>{
       
            return next()
    }},  
    {path:'/estado/serach/:ncm/:uf',name:'estado', component: NCM,beforeEnter:(to,from,next)=>{
        return next();
    }}  
    //{path:'/relp/:info',name:'info', component: Principal},    

];